import { Badge } from '@mui/material'
import { AppAvatarProps } from 'components/core/avatar'
import { ResourceTypeBadge } from 'components/pages/entitlement/resource-type/icons'
import React from 'react'

export type EntitlementAvatarProps = {
    type: string // 'org' | 'group' | 'app' | 'repository' | 'Credential' | 'custom'
    appAvatar: React.ReactElement<AppAvatarProps>
    /** When true, badge image is decorative with empty alt. Set false when used standalone without visible text. */
    decorative?: boolean
}

export const EntitlementAvatar = ({ type, appAvatar, decorative = false }: EntitlementAvatarProps): React.ReactElement => <Badge
    overlap="circular"
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    badgeContent={<ResourceTypeBadge resourceType={type} decorative={decorative} />}
>
    {appAvatar}
</Badge>
